import React, { useState, useEffect } from "react";
import Container from "@material-ui/core/Container";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Header from "../components/Header";
import { useHistory } from "react-router-dom";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import styled from "styled-components";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { Link } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import RewardActions from "../actions/rewards.actions";
import CampaignsActions from "../actions/campaigns.actions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import { useRouteMatch } from "react-router-dom";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import CompanyProfileActions from "../actions/companyProfile.actions";

const StyledTH = styled(Th)`
  border: 1px solid #2a2727;
  background: #3f3f3f;
  color: white;
  padding-left: 10px;
`;

const StyledTD = styled(Td)`
  border: 1px solid #2a2727;
  background: #525252;
  color: white;
  padding: 10px;
`;

const StyledBtn = styled(Button)`
  color: #fff !important;
  border-color: #000 !important;
  background-color: #3f3f3f !important;
  padding-left: 25px;
  padding-right: 25px;
  width: auto;
  display: block;
  margin: auto;
  &#floating {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 50px;
    min-width: auto;
    height: 50px;
    padding: 0;
    border-radius: 50%;
  }
`;

const StyledTR = styled(Tr)`
  border-color: #2a2727 !important;
  padding: 0 !important;
`;

const StyledTextField = styled(TextField)`
  margin-bottom: 10px;
  background: #efefef !important;
  border-color: black !important;
  * {
    border-color: black !important;
  }
  label {
    color: gray!important
  }
  input {
    color: black !important;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    transition: background-color 5000s ease-in-out 0s !important;
    -webkit-text-fill-color: black !important;
  }
`;

const Rewards = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  let history = useHistory();
  const [page, setPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  let match = useRouteMatch();

  useEffect(() => {
    if (!props.auth.access_token) {
      history.push("/");
    }
  }, [props.auth.access_token]);

  useEffect(()=>{
    if (props.profile && (Object.keys(props.profile).length > 0) && !props.profile._id) {
        history.push('/profile');
    }
  },[props.profile])

  useEffect(() => {
    props.getCompanyProfile(()=>{
      props.getRewards({
        campaignId: match.params.id,
        cb: () => {
          props.getCampaignInfo(match.params.id);
        },
      });
    })
  }, []);

  const openEditModal = (rewardgroupId) => {
    props.getRewardInfo({
      campaignId: match.params.id,
      rewardgroupId,
      cb: () => {
        props.getRewards({
          campaignId: match.params.id,
        });
        setIsModalOpen(true);
      },
    });
  };

  const triggerSave = () => {
    if (props.reward._id) {
      props.updateReward({
        campaignId: match.params.id,
        rewardgroupId: props.reward._id,
        cb: () => {
          props.getRewards({
            campaignId: match.params.id,
          });
          setIsModalOpen(false);
        },
      });
    } else {
      props.createReward({
        campaignId: match.params.id,
        cb: () => {
          props.getRewards({
            campaignId: match.params.id,
          });
          setIsModalOpen(false);
        },
      });
    }
  };
  console.log(props.rewardList);
  return (
    <Container fixed>
      {
      (Object.keys(props.profile).length > 0) &&
      <Header IsProfileCreated={!!props.profile._id} label={"Rewards"}>
        <Typography component="div" align="left" style={{ marginTop: "0px" }}>
          {props.rewardList && props.rewardList.length > 0 && (
            <Table style={{ borderCollapse: "collapse" }}>
              <Thead>
                <StyledTR>
                  <StyledTH>Description</StyledTH>
                  <StyledTH>Status</StyledTH>
                  <StyledTH>Quantity</StyledTH>
                  <StyledTH>Claimed</StyledTH>
                  <StyledTH>Redeemed</StyledTH>
                  <StyledTH>Actions</StyledTH>
                </StyledTR>
              </Thead>
              <Tbody>
                {props.rewardList.map((obj, i) => {
                  return (
                    <StyledTR key={i}>
                      <StyledTD>{obj.itemDescription}</StyledTD>
                      <StyledTD>{obj.status}</StyledTD>
                      <StyledTD>{obj.quantity}</StyledTD>
                      <StyledTD style={{ color: "#fff" }}>
                        {obj.claimedCount.toString()}
                      </StyledTD>
                      <StyledTD>{obj.redeemedCount.toString()}</StyledTD>
                      <StyledTD>
                        <Link
                          to="#"
                          onClick={() => {
                            openEditModal(obj._id);
                          }}
                          style={{ color: "#fff" }}
                        >
                          Edit
                        </Link>
                      </StyledTD>
                    </StyledTR>
                  );
                })}
              </Tbody>
            </Table>
          )}
          {props.rewardList && props.rewardList.length === 0 && (
            <React.Fragment>
              <h3 style={{ textAlign: "center", color: "#3F3F3F" }}>
                You have not created any reward.
              </h3>
              <StyledBtn
                variant="outlined"
                color="primary"
                onClick={() => {
                  props.resetReward();
                  setIsModalOpen(true);
                }}
              >
                Create your first reward
              </StyledBtn>
            </React.Fragment>
          )}
          <Dialog
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            aria-labelledby="form-dialog-title"
          >
            {props.reward && props.reward._id ? (
              <DialogTitle id="form-dialog-title" style={{ paddingBottom: 0 }}>
                Edit Reward
              </DialogTitle>
            ) : (
              <DialogTitle id="form-dialog-title" style={{ paddingBottom: 0 }}>
                Add Reward
              </DialogTitle>
            )}
            <DialogContent>
              <StyledTextField
                autoFocus
                value={props.reward.itemDescription || ""}
                margin="dense"
                disabled={props.reward._id}
                id="description"
                label="Reward Description"
                fullWidth
                variant={"outlined"}
                onChange={(ev) => {
                  props.updateRewardInfo({
                    key: "itemDescription",
                    value: ev.target.value,
                  });
                }}
              />
              <StyledTextField
                value={props.reward.quantity || ""}
                autoFocus
                disabled={props.reward._id}
                variant={"outlined"}
                margin="dense"
                id="rewards_count"
                label="Rewards Count"
                type="number"
                fullWidth
                onChange={(ev) => {
                  props.updateRewardInfo({
                    key: "quantity",
                    value: ev.target.value,
                  });
                }}
              />
              {props.campaign.redemptionType === "online" && (<StyledTextField
                value={props.reward.rewardPage || ""}
                disabled={props.reward._id}
                variant={"outlined"}
                margin="dense"
                id="rewards_page"
                label="Reward Page"
                type="text"
                fullWidth
                onChange={(ev) => {
                  props.updateRewardInfo({
                    key: "rewardPage",
                    value: ev.target.value,
                  });
                }}
              />)}
              {props.campaign.redemptionType === "online" && (
                <StyledTextField
                  disabled={props.reward._id}
                  fullWidth
                  id="redemptionCodes"
                  label="Redemption Codes (comma seperated values)"
                  variant="outlined"
                  value={props.reward.redemptionCodes || ""}
                  onChange={(ev) => {
                    props.updateRewardInfo({
                      key: "redemptionCodes",
                      value: ev.target.value,
                    });
                  }}
                  multiline
                  rows={4}
                />
              )}
              {props.reward._id && (
                <div style={{ display: "flex" }}>
                  <span style={{ marginRight: "20px", lineHeight: "48px" }}>
                    Reward Status:
                  </span>
                  <ToggleButtonGroup
                    value={props.reward.status}
                    exclusive
                    onChange={(a, value) =>
                      props.updateRewardInfo({
                        key: "status",
                        value: value,
                      })
                    }
                    aria-label="text alignment"
                  >
                    <ToggleButton value="inactive">
                      <span>Inactive</span>
                    </ToggleButton>
                    <ToggleButton value="active">
                      <span>Active</span>
                    </ToggleButton>
                  </ToggleButtonGroup>
                </div>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setIsModalOpen(false)} color="primary">
                Cancel
              </Button>
              <Button onClick={() => triggerSave()} color="primary">
                Save
              </Button>
            </DialogActions>
          </Dialog>
          <StyledBtn
            variant="outlined"
            id="floating"
            color="primary"
            onClick={() => {
              props.resetReward();
              setIsModalOpen(true);
            }}
          >
            +
          </StyledBtn>
        </Typography>
      </Header>
      }
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    profile: state.companyProfile.profile,
    campaign: state.campaigns.campaign || {},
    rewardList: state.rewards.rewardList,
    reward: state.rewards.reward,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCompanyProfile: (cb) =>
    dispatch(CompanyProfileActions.getCompanyProfile(cb)),
    resetReward: () => dispatch(RewardActions.resetReward()),
    getCampaignInfo: (id) => dispatch(CampaignsActions.getCampaignInfo(id)),
    getRewards: (payload) => dispatch(RewardActions.getRewards(payload)),
    updateRewardInfo: (payload) =>
      dispatch(RewardActions.updateRewardInfo(payload)),
    createReward: (payload) => dispatch(RewardActions.createReward(payload)),
    getRewardInfo: (payload) => dispatch(RewardActions.getReward(payload)),
    updateReward: (payload) => dispatch(RewardActions.updateReward(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Rewards);
